import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'

import { service } from '@/api/api'

Vue.use(VueLocalStorage)

export default {
  state: {
    annualReport: null,
    summaryMonthReport: null,
    
  },
  getters: {
    monthReport: state => {
      if(!state.summaryMonthReport) return {}
      return {
        assistance: state.summaryMonthReport.report.assistance,
        medicalBreak: Number(state.summaryMonthReport.report.medicalBreak) + Number(state.summaryMonthReport.report.medicalBreakSubsidized),
        vacation: state.summaryMonthReport.report.vacation,
        extraHours25: state.summaryMonthReport.report.extraHours25,
        extraHours35: state.summaryMonthReport.report.extraHours35,
      }
    },
    monthlySimpleHours: (state) => (month, year) => {
      console.log(month, year);
      if(!state.annualReport) return 0
      console.log(state.annualReport.filter((day) => day.status == "assistance" && new Date(day.date).getMonth() == month-1));
      return state.annualReport.reduce((acc, day) => {
        if(day.status == "assistance" && new Date(day.date).getMonth() == month-1 && new Date(day.date).getFullYear() === (year || new Date().getFullYear())){
          return acc + day.contractual
        }else {
          return acc + 0
        }
      }, 0)
    }
  },
  mutations: {
    ['SET_ANNUALREPORT'](state,payload){
      state.annualReport = new Array(...payload)
    },
    ["SET_SUMMARY_MONTH_REPORT"](state, payload){
      state.summaryMonthReport = JSON.parse(JSON.stringify(payload))
    }
  },
  actions: {
    //actualiza reporte diario
    async updateDailyReport(ctx, payload){
      let res = await service.updateDailyReport(payload)
      return res
    },
    //reporte anual
    async getEmployeeReport({commit}, payload){
      let res = await service.getEmployeeReport(payload)
      if(res.status == 200){
        commit('SET_ANNUALREPORT',res.data.detail)
        commit("SET_SUMMARY_MONTH_REPORT", res.data.dayReport)
      }
      return res
    },
    async setTardiness({}, payload){
      const res = await service.updateTardiness(payload);

      return res;
    }
  }
}